const CustomToolbar = ({ label }) => {
  return (
    <div className="rbc-toolbar">
      <span className="rbc-toolbar-label">{label}</span>
    </div>
  );
};

export default CustomToolbar;